import { Link } from "@repo/next-utils/router";
import { Logo } from "@/components/logo";
import { TYPOGRAPHY_LABEL1 } from "@/theme/topshop-2/typography/typography-constants";
import styles from "./index.module.css";

export const GlobalLanding = () => {
  return (
    <div className={styles.container}>
      <Link href="/topshop" className={styles.sectionLink}>
        <div className={styles.topshop}>
          <Logo
            variant="topshop"
            height={36}
            className={styles.logo}
            aria-label="Topshop"
          />
          <span className={`${TYPOGRAPHY_LABEL1} ${styles.linkText}`}>
            Shop Womenswear
          </span>
        </div>
      </Link>
      <Link href="/topman" className={styles.sectionLink}>
        <div className={styles.topman}>
          <Logo
            variant="topman"
            height={36}
            className={styles.logo}
            aria-label="Topman"
          />
          <span className={`${TYPOGRAPHY_LABEL1} ${styles.linkText}`}>
            Shop Menswear
          </span>
        </div>
      </Link>
    </div>
  );
};
